import {windowInfo as wInfo} from './WindowInfo.js';
import {pcsp} from './Pcsp.js';
import { ClassBase, ClassRootEl } from './ClassBase.js';
import {nextTick} from '../utils/nextTick.js';
import {SmoothScroll} from './SmoothScroll.js';

export interface FormErrorOp {
	/**
	 * エラーフィールド要素
	 * @defaultValue () => $('.form_error').filter((i, el) => !!($(el).text())).closest('td')
	 */
	errFieldClass: string | HTMLElement | JQuery<any> | (() => string | HTMLElement | JQuery<any>),

	/**
	 * CONFIG.scrollOffsetから追加のオフセット値
	 */
	offset?: {
		/**
		 * PC時の追加オフセット
		 * @defaultValue 0
		 */
		pc?: number,

		/**
		 * SP時の追加オフセット
		 * @defaultValue 0
		 */
		sp?: number,
	},
}

/**
 * フォームでエラーが発生したときに最初のエラーまでスクロールさせる
 */
export class FormError extends ClassBase {
	/**
	 * 設定されているオプション
	 */
	op: FormErrorOp = {
		errFieldClass: () => $('.form_error').filter((i, el) => !!($(el).text())).closest('td'),
		offset: {
			pc: 0,
			sp: 0,
		},
	};

	constructor(el: ClassRootEl, op? : FormErrorOp) {
		super(el);
		this.op = {
			...this.op,
			...op,
		}
		this.#init()

	}

	/**
	 * 最初のエラーフィールドまでスクロールさせる
	 */
	scroll(){
		let $el = (typeof this.op.errFieldClass == 'function') ? $(this.op.errFieldClass()) : $(this.op.errFieldClass);
		$el = $el.filter((i, el) => !$(el).closest('.hidden')[0])

		if (!$el[0]) { return }
		new SmoothScroll(null, {
			offset: this.op.offset
		}).to($el)
	}

	#init(){
		$(window).on('load', () => {
			nextTick(() => {
				this.scroll()
			})
		});
	}
}

export const formError = new FormError(null);